
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/ir",
      function () {
        return require("private-next-pages/contact/ir/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact/ir"])
      });
    }
  